import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class HealthCheckService {
  private http = inject(HttpClient);

  /**
   * Fires a one-off /api/health check. Response is a Base64-encoded JSON
   * string (same pattern as /simulation) — decode with atob() then JSON.parse().
   * Intended to run once right after login completes, not on every dashboard visit.
   */
  triggerHealthCheck(): void {
    this.http
      .get('/api/health1', { withCredentials: true, responseType: 'text' })
      .subscribe({
        next: (base64) => {
          try {
            const jsonString = atob(base64);
            const data = JSON.parse(jsonString);
            console.log('[HealthCheckService] Health endpoint decoded JSON:', data);
          } catch (e) {
            console.error('[HealthCheckService] Failed to decode/parse health response:', e, 'raw:', base64);
          }
        },
        error: (err) => {
          console.error('[HealthCheckService] Health endpoint error:', err);
        },
      });
  }
}